import { useQuery } from 'react-query';
import axios from 'axios';

const MAXIMUM_NUMBER_OF_RETRIES = 20;

async function getVimeoStatus(houseId) {
  const videoResult = await axios.get(`/kodak-api/api/v1/media/videos/HOUSE/${houseId}`);
  const videoUrls = videoResult?.data?.items;
  if (!videoUrls || !videoUrls.length) {
    return null;
  }
  return videoUrls.filter(videoUrl => videoUrl.videoSource === 'VIMEO');
}

async function pollVimeoStatus(houseId, numberOfRetries) {
  if (numberOfRetries > MAXIMUM_NUMBER_OF_RETRIES) {
    throw new Error('Retries count exceeded');
  }
  const vimeoVideos = await getVimeoStatus(houseId);
  const completedVideo = vimeoVideos?.find(video => video.status === 'transcode_complete');

  if (completedVideo) {
    return completedVideo;
  }
  const videoWithError = vimeoVideos?.find(video => video.status === 'transcode_error');
  if (videoWithError) {
    throw new Error('transcoding error');
  }

  const currentNumberOfRetries = vimeoVideos ? numberOfRetries : numberOfRetries + 1;
  await new Promise(resolve => setTimeout(resolve, 3000));
  return pollVimeoStatus(houseId, currentNumberOfRetries);
}

export const useGetVimeoStatus = (houseId, enabled) =>
  useQuery(
    ['poller'],
    () => pollVimeoStatus(houseId, 0),
    {
      retry: false,
      enabled,
    }
  );
